import api from './api';

const incidentService = {
  /**
   * Report a new incident.
   */
  async create(incidentData) {
    const response = await api.post('/incidents', incidentData);
    return response.data;
  },

  /**
   * List incidents for the current organisation, optionally filtered.
   */
  async getAll(params = {}) {
    const response = await api.get('/incidents', { params });
    return response.data;
  },

  /**
   * Get a single incident by ID.
   */
  async getById(id) {
    const response = await api.get(`/incidents/${id}`);
    return response.data;
  },

  /**
   * Update an incident (status, investigation notes, corrections).
   */
  async update(id, incidentData) {
    const response = await api.patch(`/incidents/${id}`, incidentData);
    return response.data;
  },

  /**
   * Delete an incident.
   */
  async delete(id) {
    const response = await api.delete(`/incidents/${id}`);
    return response.data;
  },

  // ---- Evidence attached to an incident ----

  async uploadEvidence(incidentId, file, fileType = 'photo') {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileType', fileType);
    const response = await api.post(`/evidence/incident/${incidentId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  async getEvidence(incidentId) {
    const response = await api.get(`/evidence/incident/${incidentId}`);
    return response.data;
  },

  async deleteEvidence(evidenceId) {
    const response = await api.delete(`/evidence/${evidenceId}`);
    return response.data;
  },
};

export default incidentService;
